import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'workist_demo',
} as IModuleProps;
